import styled from "styled-components";

export const CssHome = styled.div`
  width: 100%;
  background: #ff0b05;
  font-family: "Barlow", sans-serif;

  .caseHero {
    width: 100%;
    min-height: 560px;
    background: #ff0b05;
    position: relative;
    margin-top: 75px;
    overflow: hidden;
  }

  .caseContainer {
    width: 100%;
    min-height: 560px;
    position: relative;
    padding: 43px 16.5% 0;
    box-sizing: border-box;
  }
  

  .caseIntro {
    width: 100%;
    position: relative;
    min-height: 460px;
  }

  .caseIntro h1 {
    position: absolute;
    top: 82px;
    left: 0;
    margin: 0;
    color: #2befff;
    font-size: clamp(38px, 4.1vw, 60px);
    line-height: 1.18;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: -0.055em;
    overflow: hidden;
  }

  .titleLine {
    display: block;
    will-change: transform, opacity, filter;
  }

  .titleRealTime {
    animation: titleFromLeft 0.9s cubic-bezier(0.22, 1, 0.36, 1) both;
  }

  .titleProducao {
    opacity: 0;
    animation: titleFromBottomLight 1s cubic-bezier(0.22, 1, 0.36, 1) 0.35s both;
  }

  .caseIntro p {
    position: absolute;
    top: 302px;
    right: 0;
    max-width: 650px;
    width: 46%;
    margin: 0;
    color: #2befff;
    font-size: clamp(16px, 1.35vw, 20px);
    line-height: 1.15;
    font-weight: 400;
    text-align: right;
    letter-spacing: -0.055em;
    opacity: 0;
    animation: textFadeIn 1s ease 0.95s both;
  }

  @keyframes titleFromLeft {
    from {
      opacity: 0;
      transform: translateX(-120px);
    }

    to {
      opacity: 1;
      transform: translateX(0);
    }
  }

  @keyframes titleFromBottomLight {
    0% {
      opacity: 0;
      transform: translateY(60px);
    }

    65% {
      opacity: 0.55;
      transform: translateY(0);
    }

    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes textFadeIn {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }

  @media (max-width: 1366px) {
	.caseContainer {			
		padding: 43px 5.5% 0;
	
	}
}



  @media (max-width: 1100px) {
    .caseContainer {
      padding: 38px 3% 0;
	      min-height: 500px;
    }

	.caseHero {
		min-height: 500px;
	}

    .caseIntro h1 {
      top: 85px;
    }

    .caseIntro p {
      top: 310px;
      width: 52%;
    }
  }

  @media (max-width: 900px) {
    .caseHero,
    .caseContainer {
      min-height: 490px;
    }

    .caseContainer {
      padding: 38px 32px 0;
    }

    .caseNav {
      font-size: 17px;
    }

    .caseNav img {
      width: 13px;
    }

    .caseIntro {
      min-height: 480px;
    }

    .caseIntro h1 {
      top: 85px;
      left: 0;
      right: 0;
      font-size: 42px;
      line-height: 1.15;
    }

    .caseIntro p {
      top: 280px;
      left: 0;
      right: auto;
      width: 100%;
      max-width: 500px;
      text-align: left;
      font-size: 17px;
    }
  }

  @media (max-width: 600px) {    

    .caseContainer {
      padding: 32px 24px 0;
    }

    .caseTop {
      align-items: flex-start;
    }

    .caseNav {
      font-size: 14px;
    }

    .caseNav img {
      width: 11px;
    }

    .caseIntro h1 {
      top: 82px;
      font-size: 34px;
      line-height: 1.15;
    }

    .caseIntro p {
      top: 245px;
      width: 100%;
      max-width: none;
      font-size:20px;
      line-height: 1.4;
    }

    @keyframes titleFromLeft {
      from {
        opacity: 0;
        transform: translateX(-70px);
      }

      to {
        opacity: 1;
        transform: translateX(0);
      }
    }

    @keyframes titleFromBottomLight {
      0% {
        opacity: 0;
        transform: translateY(35px);
      }

      65% {
        opacity: 0.55;
        transform: translateY(0);
      }

      100% {
        opacity: 1;
        transform: translateY(0);
      }
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .titleRealTime,
    .titleProducao,
    .caseIntro p {
      animation: none;
      opacity: 1;
      transform: none;
    }

    .caseNav img {
      transition: none;
    }
  }
`;

export const CardCss = styled.div`
  width: 100%;
  background: #f5efd9;
  font-family: "Barlow", sans-serif;
  overflow: hidden;

  .cardsSection {
    width: 100%;
    background: #f5efd9;
    position: relative;
    padding: 55px 0 70px;
  }

  .cardsContainer {
    width: 100%;
    max-width: 1440px;
    margin: 0 auto;
    position: relative;
    padding: 0 7.4%;
    box-sizing: border-box;
  }

  .cardsHeader {
    width: 100%;
    min-height: 140px;
    position: relative;
    display: flex;
    align-items: flex-start;
  }

  .saoPauloLogo {
    width: 125px;
    max-width: 18vw;
    height: auto;
    display: block;
    position: relative;
    z-index: 2;
  }

  .cardsText {
    width: 465px;
    max-width: 38vw;
    margin: 35px 0 0 58px;
    color: #ff0b05;
    font-size: 18px;
    line-height: 1.08;
    font-weight: 500;
    letter-spacing: -0.06em;
  }

  .bigArrow {
    position: absolute;
    top: -80px;
    right: 5.6%;
    width: 155px;
    height: auto;
    display: block;
  }

  .instaRow {
    width: calc(100% + 11%);
    margin-left: -7.4%;
    margin-top: 10px;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 0px;
    align-items: start;
    position: relative;
    z-index: 3;
  }

  .instaCard {
    width: 100%;
    height: auto;
    display: block;
    transition: transform 0.35s ease, filter 0.35s ease;
    will-change: transform;
  }

  .instaCard:hover {
    transform: scale(1.045) rotate(var(--cardRotate));
    filter: drop-shadow(0 16px 18px rgba(0, 0, 0, 0.50));
  }

  .instaCard1 {
    --cardRotate: 1.8deg;
    transform: rotate(1.8deg);
  }

  .instaCard2 {
    --cardRotate: 1.8deg;
    transform: rotate(1.8deg);
    margin-top: 10px;
  }

  .instaCard3 {
     --cardRotate: 1.8deg;
    transform: rotate(1.8deg);
    margin-top: 22px;
  }

  .instaCard4 {
    --cardRotate:  1.8deg;
    transform: rotate( 1.8deg);
    margin-top: 33px;
  }

  .resultsArea {
    width: 100%;
    min-height: 565px;
    position: relative;
    margin-top: 35px;
  }

  .triangle {
    width: 110px;
    height: auto;
    position: absolute;
    display: block;
  }

  .triangleLeft {
    top: -24px;
    left: -5%;
  }

  .mediaWrap {
    width: 58%;
    min-height: 570px;
    position: relative;
    z-index: 3;
  }

  .moldura {
    position: absolute;
    left: -7.4%;
    top: 88px;
    width: 80%;
    max-width:580px;
    height: auto;
    display: block;
  }

  .celular {
    position: absolute;
    left:56%;
    top: 0;
    width: 45%;
    max-width: 360px;
    height: auto;
    display: block;
    z-index: 4;
    filter: drop-shadow(0 22px 22px rgba(0, 0, 0, 0.3));
  }

  .numbersWrap {
    position: absolute;
    top: 125px;
    right: 10%;
    width: 48%;
    min-height: 360px;
    z-index: 2;
  }

  .numberBox {
    color: #ff0b05;
    box-sizing: border-box;
	text-align: right
  }

  .numberBox strong {
    display: block;
    font-size: clamp(48px, 5.4vw, 82px);
    line-height: 0.85;
    font-weight: 800;
    letter-spacing: -0.055em;
  }

  .numberBox span {
    display: block;
    font-size: clamp(13px, 1.1vw, 18px);
    line-height: 1;
    font-weight: 500;
    letter-spacing: -0.05em;
  }

  .numberBoxRed {
    width: 100%;
    background: #ff0b05;
    color: #f5efd9;
    padding: 18px 22px 16px;
	text-align: right
  }

  .numberBoxOutline {
    width: 70%;
    min-height: 97px;
    margin-left: 18%;
    margin-top: 24px;
    border: 1px solid #ff0b05;
    padding: 14px 60px 12px;
    background: transparent;
  }

  .numberBoxSpeakers {
    width: 56%;
    min-height: 88px;
    margin-left: 26%;
    margin-top: 18px;
    padding: 14px 44px 12px;
  }

  .triangleRight {
   	right: 6.5%;
    bottom: -20px;
    transform: rotate(0deg);
  }

  .scrollItem {
    opacity: 0;
    will-change: transform, opacity;
  }

  &.isVisible .logoAnim {
    animation: fromLeftFade 0.8s cubic-bezier(0.22, 1, 0.36, 1) both;
  }

  &.isVisible .textAnim {
    animation: fadeOnly 0.8s ease 0.15s both;
  }

  &.isVisible .arrowAnim {
    animation: fadeOnly 0.85s ease 0.25s both;
  }

  &.isVisible .instaCard1 {
    animation: cardFromLeft1 0.8s cubic-bezier(0.22, 1, 0.36, 1) 0.42s both;
  }

  &.isVisible .instaCard2 {
    animation: cardFromLeft2 0.8s cubic-bezier(0.22, 1, 0.36, 1) 0.58s both;
  }

  &.isVisible .instaCard3 {
    animation: cardFromLeft3 0.8s cubic-bezier(0.22, 1, 0.36, 1) 0.74s both;
  }

  &.isVisible .instaCard4 {
    animation: cardFromLeft4 0.8s cubic-bezier(0.22, 1, 0.36, 1) 0.9s both;
  }

  &.isVisible .triangleLeftAnim {
    animation: fromLeftFade 0.8s cubic-bezier(0.22, 1, 0.36, 1) 1.05s both;
  }

  &.isVisible .molduraAnim {
    animation: molduraFromLeft 0.95s cubic-bezier(0.22, 1, 0.36, 1) 1.18s both;
  }

  &.isVisible .celularAnim {
    animation: celularAppear 0.9s cubic-bezier(0.22, 1, 0.36, 1) 1.55s both;
  }

  &.isVisible .number400Anim {
    animation: fromRightFade 0.8s cubic-bezier(0.22, 1, 0.36, 1) 1.9s both;
  }

  &.isVisible .number20Anim {
    animation: fromRightFade 0.8s cubic-bezier(0.22, 1, 0.36, 1) 2.1s both;
  }

  &.isVisible .numberSpeakersAnim {
    animation: fromRightFade 0.8s cubic-bezier(0.22, 1, 0.36, 1) 2.22s both;
  }

  &.isVisible .triangleRightAnim {
    animation: fromLeftFadeRotate 0.75s cubic-bezier(0.22, 1, 0.36, 1) 2.36s both;
  }

  @keyframes fromLeftFade {
    from {
      opacity: 0;
      transform: translateX(-90px);
    }

    to {
      opacity: 1;
      transform: translateX(0);
    }
  }

  @keyframes fromRightFade {
    from {
      opacity: 0;
      transform: translateX(90px);
    }

    to {
      opacity: 1;
      transform: translateX(0);
    }
  }

  @keyframes fadeOnly {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }

  @keyframes cardFromLeft1 {
	from {
		opacity: 0;
		transform: translateX(-110px) rotate(1.8deg);
	}

	to {
		opacity: 1;
		transform: translateX(0) rotate(1.8deg);
	}
	}

	@keyframes cardFromLeft2 {
	from {
		opacity: 0;
		transform: translateX(-110px) rotate(1.8deg);
	}

	to {
		opacity: 1;
		transform: translateX(0) rotate(1.8deg);
	}
	}

	@keyframes cardFromLeft3 {
	from {
		opacity: 0;
		transform: translateX(-110px) rotate(1.8deg);
	}

	to {
		opacity: 1;
		transform: translateX(0) rotate(1.8deg);
	}
	}

	@keyframes cardFromLeft4 {
	from {
		opacity: 0;
		transform: translateX(-110px) rotate(1.8deg);
	}

	to {
		opacity: 1;
		transform: translateX(0) rotate(1.8deg);
	}
	}

  @keyframes molduraFromLeft {
    from {
      opacity: 0;
      transform: translateX(-120px);
    }

    to {
      opacity: 1;
      transform: translateX(0);
    }
  }

  @keyframes celularAppear {
    from {
      opacity: 0;
      transform: translate(-50px, 45px) rotate(-5deg) scale(0.9);
    }

    to {
      opacity: 1;
      transform: translate(0, 0) rotate(0deg) scale(1);
    }
  }

  @keyframes fromLeftFadeRotate {
    from {
      opacity: 0;
      transform: translateX(-80px) rotate(0deg);
    }

    to {
      opacity: 1;
      transform: translateX(0) rotate(0deg);
    }
  }

  	.afterMovieArea {
		width: calc(100% + 14.8%);
		margin-left: -7.4%;
		margin-top: 40px;
		min-height: 520px;
		position: relative;
		overflow: hidden;
		/* background: #ff0b05; */
	}

	.afterMovieBg {
		position: absolute;
		inset: 0;
		width: 100%;
		height: 100%;
		object-fit: cover;
		display: block;
		z-index: 1;
	}

	.afterMovieContent {
		width: 100%;
		min-height: 520px;
		position: relative;
		z-index: 2;
		display: grid;
		grid-template-columns: 32% 64%;
		align-items: center;
		padding: 0 4.5% 0 5%;
		box-sizing: border-box;
	}

	.afterMovieTextBox {
		color: #fff;
		text-align: right;
		padding-right: 34px;
		box-sizing: border-box;
		margin-top: 50px;
	}

	.afterMovieLogo {
		width: 65px;
		height: auto;
		display: block;
		margin: 0 0 18px auto;
	}

	.afterMovieTextBox h2 {
		margin: 0 0 22px;
		color: #fff;
		font-size: clamp(38px, 4vw, 58px);
		line-height: 0.9;
		font-weight: 800;
		letter-spacing: -0.055em;
		text-transform: uppercase;
	}

	.afterMovieTextBox p {
		margin: 0;
		color: #fff;
		font-size: clamp(18px, 1.55vw, 24px);
		line-height: 1.18;
		font-weight: 400;
		letter-spacing: -0.06em;
	}

	.afterMovieVideoBox {
		width: 100%;
		position: relative;
		z-index: 3;
		margin-left: 7%;
	}

	.afterMovieVideoBox iframe {
		width: 100%;
		height: 480px;		
	}

	&.isVisible .afterMovieInfoAnim {
		animation: afterMovieInfoFromLeft 0.9s cubic-bezier(0.22, 1, 0.36, 1) 2.55s both;
		}

		&.isVisible .afterMovieVideoAnim {
		animation: afterMovieVideoAppear 0.95s cubic-bezier(0.22, 1, 0.36, 1) 2.95s both;
		}

		@keyframes afterMovieInfoFromLeft {
		from {
			opacity: 0;
			transform: translateX(-120px);
		}

		to {
			opacity: 1;
			transform: translateX(0);
		}
		}

		@keyframes afterMovieVideoAppear {
		from {
			opacity: 0;
			transform: translateX(70px) scale(0.96);
		}

		to {
			opacity: 1;
			transform: translateX(0) scale(1);
		}
	}


	@media (max-width: 1024px) {
		.afterMovieVideoBox iframe {
			height: 310px;
		}
	}

  @media (max-width: 1100px) {
    .cardsSection {
      padding-top: 48px;
    }

    .cardsContainer {
      padding: 0 2%;
    }

    .cardsText {
      margin-left: 42px;
      width: 370px;
      max-width: 42vw;
      font-size: 16px;
    }

    .bigArrow {
      width: 130px;
      right: 4%;
    }

    .instaRow {
      width: 100%;
      margin-left: 0;
   
    }

    .resultsArea {
      min-height:490px;
      margin-top: 20px;
    }

    .moldura {
      left: 0;
      width: 80%;
    }

    .celular {
      left: 65%;
      width: 45%;
    }

    .numbersWrap {
      width: 48%;
      right: 0;
    }

	.afterMovieArea {
		width: calc(100% + 4%);
		margin-left: -2%;
	}

	.afterMovieContent {
		grid-template-columns: 34% 66%;
		padding: 0 3%;
	}

	.afterMovieTextBox {
		padding-right: 24px;
	}

	.afterMovieVideoBox iframe {
		height: 420px;
	}
  }

  @media (max-width: 900px) {
    .cardsSection {
      padding: 44px 0 60px;
    }

    .cardsContainer {
      padding: 0 32px;
    }

    .cardsHeader {
      min-height: auto;
      display: block;
    }

    .saoPauloLogo {
      width: 120px;
      max-width: none;
    }

    .cardsText {
      width: 100%;
      max-width: 520px;
      margin: 28px 0 0;
      font-size: 17px;
      line-height: 1.15;
    }

    .bigArrow {
      top: -65px;
      right: 25px;
      width: 105px;
    }

    .instaRow {
      margin-top: 35px;
      grid-template-columns: repeat(4, 1fr);
      gap: 0px;
    }

    .resultsArea {
      min-height: auto;
      margin-top: 15px;
      display: flex;
      flex-direction: column;
    }

    .triangleLeft {
      top: -22px;
      left: -16%;
      width: 70px;
    }

    .mediaWrap {
      width: 100%;
      min-height: 540px;
    }

    .moldura {
      left: 0;
      top: 120px;
      width: 58%;
      max-width: 420px;
    }

    .celular {
      left: 33%;
      top: 20px;
      width: 35%;
      max-width: 310px;
    }

    .numbersWrap {     
      top: 24%;
      right: 0;
      width: 60%;
      min-height: 340px;
    }

    .numberBoxRed {
      width: 78%;
      margin-left: auto;
    }

    .numberBoxOutline {
      width: 56%;
      margin-left: auto;
      margin-right: 8%;
    }

    .numberBoxSpeakers {
      width: 48%;
      margin-right: 3%;
    }

    .triangleRight {
      	right: -10px;
        bottom: -8px;
        width: 70px;
    }

	.afterMovieArea {
		width: calc(100% + 64px);
		margin-left: -32px;
		min-height: auto;
		margin-top: 20px;
		background: #ff0b05;
	}

	.afterMovieContent {
		min-height: auto;
		grid-template-columns: 1fr;
		padding: 25px 32px;
		row-gap: 34px;
	}

	.afterMovieTextBox {
		text-align: left;
		padding-right: 0;
		max-width: 520px;
	}

	.afterMovieLogo {
		margin: 0 0 18px 0;
		width: 90px;
	}

	.afterMovieVideoBox {
	margin-left: 0%;
	}

	.afterMovieVideoBox img {
		height: 200px
	}
  }

  @media (max-width: 620px) {
  	&.isVisible .scrollItem {
		opacity: 1;
	}

    .cardsContainer {
      padding: 0 24px;
    }

    .bigArrow {
        width: 102px;
        top: -59px;
        right: -15px;
    }

    .instaRow {
        grid-template-columns: repeat(2, 1fr);
        gap: 1px;
        margin-top: 36px;
    }

    .instaCard {
      max-width: 360px;
      margin-left: auto;
      margin-right: auto;
    }

        .numbersWrap{
                position: relative;
                width: 100%;
                top: auto;
                right: auto;
        }

    .instaCard2,
    .instaCard3,
    .instaCard4 {
      margin-top: 0;
    }

    .resultsArea {
      margin-top: -30px;
    }

    .mediaWrap {
      min-height: 435px;
    }

	.triangleLeft{
		display: none
	}

    .moldura {
      top: 150px;
      width: 90%;
      max-width: none;
      left: -27%;
    }

    .celular {
        top: 17%;
        left: 50%;
        width: 50%;
     	max-width: none;
    }

    .numberBoxRed {
      width: 100%;
      padding: 16px 18px 15px;
	  text-align: center;
    }

    .numberBoxOutline {
      width: 100%;
      margin-left: auto;
      margin-right: 0;
	  text-align: center;
    }

    .numberBoxSpeakers {
      margin-top: 14px;
    }

    .numberBox strong {
      font-size: 52px;
    }

    .numberBox span {
      font-size: 14px;
    }

	.afterMovieVideoBox {
	margin-left: 0;
	}

	.afterMovieVideoBox iframe {
        height: 210px;
    }

  }

  @media (prefers-reduced-motion: reduce) {
    .scrollItem {
      animation: none !important;
      opacity: 1 !important;
      transform: none !important;
    }

    .triangleRight {
      transform: rotate(0deg) !important;
    }

    .instaCard1 {
      transform: rotate(1.8deg) !important;
    }

    .instaCard2 {
      transform: rotate(1.8deg) !important;
    }

    .instaCard3 {
      transform: rotate(1.8deg) !important;
    }

    .instaCard4 {
      transform: rotate(1.8deg) !important;
    }
  }
`;

export const ProxximaCss = styled.div`
  width: 100%;
  background: #72ddea;
  font-family: "Barlow", sans-serif;
  overflow: hidden;

  .proxximaSection {
    width: 100%;
    min-height: 900px;
    background: #72ddea;
    position: relative;
    overflow: hidden;
    padding: 72px 0 70px;
  }

  .proxximaContainer {
    width: 100%;
    max-width: 1440px;
    min-height: 780px;
    margin: 0 auto;
    position: relative;
    padding: 0 7.6%;
    box-sizing: border-box;
  }

  .proxximaHeader {
    position: relative;
    z-index: 8;
    display: flex;
    align-items: flex-start;
  }

  .proxximaLogo {
    width: 270px;
    height: auto;
    display: block;
  }

  .proxximaIntroText {
    width: 620px;
    margin: 0 0 0 72px;
    color: #ff0b05;
    font-size: 18px;
    line-height: 1.12;
    font-weight: 500;
    letter-spacing: -0.06em;
  }

  .proxximaCard {
    position: absolute;
    top: 86px;
    right: 75px;
    width: 560px;
    height: auto;
    display: block;
    z-index: 4;
  }

  .proxximaPhone {
    position: absolute;
    top: 145px;
    left: 43%;
    width: 385px;
    height: auto;
    display: block;
    z-index: 7;
    filter: drop-shadow(0 28px 22px rgba(0, 0, 0, 0.32));
  }

  .proxximaNumbers {
    position: absolute;
    top: 230px;
    left: 13.4%;
    width: 600px;
    z-index: 5;
  }

  .proxximaNumber {
    position: relative;
    background: #ff0b05;
    color: #fff7dd;
    box-sizing: border-box;
    text-align: left;
  }

  .proxximaNumber strong {
    display: block;
    font-size: clamp(58px, 5.8vw, 92px);
    line-height: 0.82;
    font-weight: 800;
    letter-spacing: -0.06em;
  }

  .proxximaNumber span {
    display: block;
    margin-top: 7px;
    font-size: clamp(15px, 1.15vw, 19px);
    line-height: 1;
    font-weight: 400;
    letter-spacing: -0.055em;
  }

  .proxximaNumberSmall {
    width: 410px;
    min-height: 128px;
    margin-left: 150px;
    padding: 27px 38px 18px;
  }

  .proxximaNumberBig {
    width: 610px;
    min-height: 120px;
    margin-top: 16px;
    padding: 24px 64px 20px;
  }

  .proxximaNumberTriangle, .proxximaNumberTriangle2{
    position: absolute;
    width: 75px;
    height: auto;
    display: block;
	transform: rotate(180deg);
  }

	.proxximaNumberTriangle2{
	 width: 120px;
	}

  .triangleSmall {
    left: -22px;
    top: -23px;
  }

  .triangleBig {
    left: -26px;
    top: -20px;
  }

  .proxximaBottom {
    position: absolute;
    left: 7.8%;
    bottom: 54px;
    z-index: 9;
    display: flex;
    align-items: flex-start;
    gap: 18px;
  }

  .proxximaBottom img {
    width: 33px;
    height: auto;
    display: block;
    margin-top: -5px;
    transform: rotate(265deg);
  }

  .proxximaBottom p {
    width: 420px;
    margin: 12px 0 0;
    color: #ff0b05;
    font-size: 18px;
    line-height: 1.12;
    font-weight: 500;
    letter-spacing: -0.06em;
  }

  .proxximaScroll {
    opacity: 0;
    will-change: transform, opacity;
  }

  &.isVisible .proxximaLogoAnim {
    animation: proxximaFromLeft 0.85s cubic-bezier(0.22, 1, 0.36, 1) both;
  }

  &.isVisible .proxximaIntroTextAnim {
    animation: proxximaFromTop 0.85s cubic-bezier(0.22, 1, 0.36, 1) 0.28s both;
  }

  &.isVisible .proxximaCardAnim {
    animation: proxximaCardAppear 0.9s cubic-bezier(0.22, 1, 0.36, 1) 0.72s both;
  }

  &.isVisible .proxximaPhoneAnim {
    animation: proxximaPhoneFromLeft 0.95s cubic-bezier(0.22, 1, 0.36, 1) 1.08s both;
  }

  &.isVisible .proxximaNumberSmallAnim {
    animation: proxximaNumberBehind 0.85s cubic-bezier(0.22, 1, 0.36, 1) 1.5s both;
  }

  &.isVisible .proxximaNumberBigAnim {
    animation: proxximaNumberBehind 0.85s cubic-bezier(0.22, 1, 0.36, 1) 1.68s both;
  }

  &.isVisible .proxximaBottomAnim {
    animation: proxximaBottomAppear 0.85s cubic-bezier(0.22, 1, 0.36, 1) 2.05s both;
  }

  @keyframes proxximaFromLeft {
    from {
      opacity: 0;
      transform: translateX(-110px);
    }

    to {
      opacity: 1;
      transform: translateX(0);
    }
  }

  @keyframes proxximaFromTop {
    from {
      opacity: 0;
      transform: translateY(-70px);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes proxximaCardAppear {
    from {
      opacity: 0;
      transform: translateX(120px) scale(0.96);
    }

    to {
      opacity: 1;
      transform: translateX(0) scale(1);
    }
  }

  @keyframes proxximaPhoneFromLeft {
    from {
      opacity: 0;
      transform: translateX(-130px) rotate(-5deg) scale(0.94);
    }

    to {
      opacity: 1;
      transform: translateX(0) rotate(0deg) scale(1);
    }
  }

  @keyframes proxximaNumberBehind {
    from {
      opacity: 0;
      transform: translateX(-90px);
    }

    to {
      opacity: 1;
      transform: translateX(0);
    }
  }

  @keyframes proxximaBottomAppear {
    from {
      opacity: 0;
      transform: translateX(-90px);
    }

    to {
      opacity: 1;
      transform: translateX(0);
    }
  }

  @media (max-width: 1366px) {
    .proxximaContainer {
      padding: 0 6%;
    }

    .proxximaLogo {
      width: 230px;
    }

    .proxximaIntroText {
      width: 520px;
      margin-left: 60px;
      font-size: 19px;
    }

    .proxximaPhone {
      left: 43%;
      width: 350px;
    }

    .proxximaCard {
      right: 0;
      width: 590px;
    }

    .proxximaNumbers {
      left: 10%;
      width: 560px;
    }

    .proxximaNumberSmall {
      width: 380px;
      margin-left: 135px;
    }

    .proxximaNumberBig {
      width: 560px;
    }
  }

  @media (max-width: 1100px) {
    .proxximaSection {
      min-height: 820px;
    }

    .proxximaContainer {
      padding: 0 32px;
      min-height: 700px;
    }

    .proxximaLogo {
      width: 205px;
    }

    .proxximaIntroText {
      width: 440px;
      margin-left: 48px;
      font-size: 17px;
    }

    .proxximaPhone {
      top: 160px;
      left: 42%;
      width: 315px;
    }

    .proxximaCard {
        top: 115px;
        right: -50px;
        width: 460px;
    }

    .proxximaNumbers {
      top: 250px;
      left: 6%;
      width: 490px;
    }

    .proxximaNumberSmall {
      width: 340px;
      margin-left: 105px;
    }

    .proxximaNumberBig {
      width: 490px;
    }

    .proxximaBottom {
      left: 32px;
      bottom: 48px;
    }

	 .proxximaBottom p{
	 	width: 340px;
	 }
  }

  @media (max-width: 900px) {
    .proxximaSection {
      min-height: auto;
      padding: 55px 0 70px;
    }

    .proxximaContainer {
      min-height: auto;
      padding: 0 32px;
      display: flex;
      flex-direction: column;
    }

    .proxximaHeader {
      display: block;
    }

    .proxximaLogo {
      width: 190px;
    }

    .proxximaIntroText {
      width: 100%;
      max-width: 560px;
      margin: 28px 0 0;
      font-size: 18px;
      line-height: 1.16;
    }

    .proxximaNumbers {
      position: relative;
      top: auto;
      left: auto;
      width: 50%;
      margin-top: 48px;
      order: 2;
    }

    .proxximaNumberSmall {
      width: 76%;
      margin-left: auto;
      padding: 22px 28px 18px;
    }

    .proxximaNumberBig {
      width: 100%;
      margin-top: 18px;
      padding: 22px 34px 18px;
    }

    .proxximaPhone {      
        top: 25%;
        left: 38%;
        width: 70%;
        max-width: 270px;      	
      	order: 3;
    }

    .proxximaCard {
		top: 15%;
		right: -5%;
		width: 60%;
		max-width: none;
      	order: 4;
    }

    .proxximaBottom {
      position: relative;
      left: auto;
      bottom: auto;
      order: 5;
      margin-top: 32px;
    }
	
	.proxximaBottom p {
        width: 200px;
    }

  }

  @media (max-width: 620px) {
    .proxximaSection {
      padding: 48px 0 60px;
    }

    .proxximaContainer {
      padding: 0 24px;
    }

    .proxximaLogo {
      width: 170px;
    }

    .proxximaIntroText {
      font-size: 17px;
    }

    .proxximaNumbers {
      margin-top: 65px;
	  width: 63%;
    }

    .proxximaNumberSmall,
    .proxximaNumberBig {
      width: 100%;
      margin-left: 0;
      padding: 18px 18px 16px;
      text-align: center;
    }

    .proxximaNumber strong {
      font-size: 56px;
    }

    .proxximaNumber span {
      font-size: 14px;
    }

    .proxximaNumberTriangle {
      width: 62px;
    }

	.proxximaNumberTriangle, .proxximaNumberTriangle2{
		position: absolute;
		width: 75px;
		height: auto;
		display: block;
		transform: rotate(180deg);
	}

    .triangleSmall,
    .triangleBig {
      left: -15px;
      top: -16px;
    }

    .proxximaPhone {
        width: 50%;
        margin-top: 10px;
        left: 49%;
    }

    .proxximaCard {
      	width: 70%;
        position: absolute;
        top: 22%;
        right: -30%;
    }

    .proxximaBottom {
      display: block;
      margin-top: 28px;
    }

    .proxximaBottom img {
      width: 58px;
      margin-bottom: 16px;
    }

    .proxximaBottom p {
      width: 75%;
      font-size: 17px;
      line-height: 1.16;
    }

    &.isVisible .proxximaScroll {
      opacity: 1;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .proxximaScroll {
      animation: none !important;
      opacity: 1 !important;
      transform: none !important;
    }
  }
`;

export const SuvinilCss = styled.div`
	width: 100%;
	background: #f5efd9;
	font-family: "Barlow", sans-serif;
	

	.suvinilSection {
		width: 100%;
		min-height: 1300px;
		background: #f5efd9;
		position: relative;	
		padding: 62px 0 0;
	}

	.suvinilContainer {
		width: 100%;
		max-width: 1440px;
		min-height: 1300px;
		margin: 0 auto;
		position: relative;
		padding: 0 7.4%;
		box-sizing: border-box;
	}

	.suvinilHeader {
		width: 100%;
		display: flex;
		align-items: flex-start;
		position: relative;
		z-index: 8;
	}

	.suvinilLogo {
		width: 205px;
		height: auto;
		display: block;
	}

	.suvinilIntroText {
		width: 760px;
		margin: 6px 0 0 68px;
		color: #ff0b05;
		font-size: 18px;
		line-height: 1.08;
		font-weight: 500;
		letter-spacing: -0.06em;
	}

	.suvinilPhotoCard {
		position: absolute;
		top: 12%;
		left: 0;
		width: 100%;
		height: auto;
		display: block;
		z-index: 2;
	}

	.suvinilZ {
		position: absolute;
		left: 20%;
		top: 55%;
		width: 238px;
		height: auto;
		display: block;
		z-index: 3;
	}

	.suvinilPhone {
		position: absolute;
		left: 32%;
		top: 560px;
		width: 560px;
		height: auto;
		display: block;
		z-index: 8;
		filter: drop-shadow(0 28px 24px rgba(0, 0, 0, 0.32));
	}

	.suvinilNumber {
		position: absolute;
		background: #ff0b05;
		color: #fff7dd;
		box-sizing: border-box;
		z-index: 5;
	}

	.suvinilNumber strong {
		display: block;
		font-size: clamp(56px, 5.2vw, 50px);
		line-height: 0.82;
		font-weight: 800;
		letter-spacing: -0.06em;
	}

	
	.triangleSmall {
		left: -22px;
		top: -23px;
	}

	.triangleSmallRight {
		right: -22px;
		top: -23px;
	}

	
	.Triangle200{
		position: absolute;
		width: 100px;
		height: auto;
		display: block;
		transform: rotate(180deg);
	}

	.Triangle900{
		position: absolute;
		width: 100px;
		height: auto;
		display: block;
		transform: rotate(-451deg);
	}

	.suvinilNumber span {
		display: block;
		margin-top: 7px;
		font-size: clamp(14px, 1.05vw, 18px);
		line-height: 1;
		font-weight: 400;
		letter-spacing: -0.055em;
	}

	.suvinilNumber900 {
		top: 64%;
    	right: 9%;
		width: 441px;
		min-height: 105px;
		padding: 20px 28px 16px;
		text-align: right;
	}

	/* .suvinilNumber900::after {
		content: "";
		position: absolute;
		right: -58px;
		top: -18px;
		width: 92px;
		height: 92px;
		border: 1px solid #ff0b05;
		background: transparent;
		z-index: -1;
	} */

	.suvinilNumber200 {
		left: 14%;
		top: 83%;
		width: 429px;
		min-height: 105px;
		padding: 20px 34px 16px;
		text-align: left;
		z-index: 7;
	}

	/* .suvinilNumber200::before {
		content: "";
		position: absolute;
		left: -24px;
		top: -22px;
		width: 105px;
		height: 105px;
		border: 1px solid #ff0b05;
		background: transparent;
		z-index: -1;
	} */

	.suvinilBottomText {
		position: absolute;
		right: 6%;
		top:83%;
		width: 480px;
		margin: 0;
		color: #ff0b05;
		font-size: 18px;
		line-height: 1.08;
		font-weight: 500;
		text-align: right;
		letter-spacing: -0.06em;
		z-index: 8;
	}

	.suvinilDentes {
		position: absolute;
		right: 0;
		bottom: -5px;
		width: 300px;
		height: auto;
		display: block;
		z-index: 2;
	}

	.suvinilScroll {
		opacity: 0;
		will-change: transform, opacity;
	}

	/* 1. Logo vem da esquerda para direita */
	&.isVisible .suvinilLogoAnim {
		animation: suvinilFromLeft 0.8s cubic-bezier(0.22, 1, 0.36, 1) both;
	}

	/* 2. Texto vem de cima para baixo */
	&.isVisible .suvinilIntroTextAnim {
		animation: suvinilFromTop 0.85s cubic-bezier(0.22, 1, 0.36, 1) 0.25s both;
	}

	/* 3. Foto/card vem de baixo para cima */
	&.isVisible .suvinilPhotoCardAnim {
		animation: suvinilFromBottom 0.9s cubic-bezier(0.22, 1, 0.36, 1) 0.62s both;
	}

	/* 4. Z azul vem da esquerda para direita */
	&.isVisible .suvinilZAnim {
		animation: suvinilFromLeft 0.85s cubic-bezier(0.22, 1, 0.36, 1) 0.98s both;
	}

	/* 5. Celular aparece depois do item 4 */
	&.isVisible .suvinilPhoneAnim {
		animation: suvinilPhoneAppear 0.95s cubic-bezier(0.22, 1, 0.36, 1) 1.38s both;
	}

	/* 6. Indicador 900 mil vem da esquerda, atrás do celular */
	&.isVisible .suvinilNumber900Anim {
		animation: suvinilNumber900FromLeft 0.85s cubic-bezier(0.22, 1, 0.36, 1) 1.78s both;
	}

	/* 7. Indicador 200k vem da direita para esquerda */
	&.isVisible .suvinilNumber200Anim {
		animation: suvinilFromRight 0.85s cubic-bezier(0.22, 1, 0.36, 1) 2.08s both;
	}

	/* 8. Texto vem depois do item 7 */
	&.isVisible .suvinilBottomTextAnim {
		animation: suvinilFromTop 0.85s cubic-bezier(0.22, 1, 0.36, 1) 2.38s both;
	}

	/* 9. Dentes vem de baixo para cima */
	&.isVisible .suvinilDentesAnim {
		animation: suvinilFromBottom 0.85s cubic-bezier(0.22, 1, 0.36, 1) 2.72s both;
	}

	@keyframes suvinilFromLeft {
		from {
			opacity: 0;
			transform: translateX(-120px);
		}

		to {
			opacity: 1;
			transform: translateX(0);
		}
	}

	@keyframes suvinilFromRight {
		from {
			opacity: 0;
			transform: translateX(120px);
		}

		to {
			opacity: 1;
			transform: translateX(0);
		}
	}

	@keyframes suvinilFromTop {
		from {
			opacity: 0;
			transform: translateY(-75px);
		}

		to {
			opacity: 1;
			transform: translateY(0);
		}
	}

	@keyframes suvinilFromBottom {
		from {
			opacity: 0;
			transform: translateY(85px);
		}

		to {
			opacity: 1;
			transform: translateY(0);
		}
	}

	@keyframes suvinilPhoneAppear {
		from {
			opacity: 0;
			transform: translateY(35px) scale(0.92);
		}

		to {
			opacity: 1;
			transform: translateY(0) scale(1);
		}
	}

	@keyframes suvinilNumber900FromLeft {
		from {
			opacity: 0;
			transform: translateX(-180px);
		}

		to {
			opacity: 1;
			transform: translateX(0);
		}
	}

	@media (max-width: 1366px) {
		.suvinilContainer {
			padding: 0 6%;
		}

		.suvinilIntroText {
			width: 700px;
			font-size: 25px;
		}

		.suvinilPhone {
			left: 31%;			
		}
		
	}

	@media (max-width: 1100px) {
		.suvinilSection {
			min-height: 980px;
		}

		.suvinilContainer {
			min-height: 940px;
			padding: 0 32px;
		}

		.suvinilLogo {
			width: 170px;
		}

		.suvinilIntroText {
			width: 560px;
			margin-left: 48px;
			font-size: 21px;
		}

		.suvinilPhotoCard {
			top: 130px;
			width: 100%;
			left: 0;
		}

		.suvinilZ {
			top: 525px;
			left: 18%;
			width: 210px;
		}

		.suvinilPhone {
			top: 420px;
			left: 30%;
			width: 410px;
		}

		.suvinilNumber900 {
			top: 585px;
			width: 330px;
			right: 45px;
		}

		.suvinilNumber200 {
			top: 770px;
			width: 350px;
			left: 6%;
		}

		.suvinilBottomText {
			top: 760px;
			right: 3%;
			width: 320px;
			font-size: 18px;
		}

		.suvinilDentes {
			width: 300px;
		}
	}

	@media (max-width: 900px) {
		.suvinilSection {
			min-height: auto;
			padding: 55px 0 70px;
		}

		.suvinilContainer {
			min-height: auto;
			padding: 0 32px;
			display: flex;
			flex-direction: column;
		}

		/* .suvinilHeader {
			display: block;
		} */

		.suvinilLogo {
			width: 165px;
		}

		.suvinilIntroText {
			width: 100%;
			max-width: 520px;		
			font-size: 21px;
			line-height: 1.14;
		}

		.suvinilPhotoCard {
			position: relative;
			top: auto;
			left: auto;
			width: calc(100% + 64px);
			margin: 42px -32px 0;
			order: 2;
		}

		.suvinilZ {
			position: relative;
			top: auto;
			left: auto;
			width: 185px;
			margin: 55px 0 0;
			order: 3;
		}

		.suvinilPhone {
			position: relative;
			top: auto;
			left: -5%;
			width: 75%;
			max-width: 470px;
			margin: -325px auto 0;
			order: 4;
		}

		
		.suvinilNumber900 {
			width: 35%;
			margin: -44px 0 0 auto;
			order: 5;
		}

		.suvinilNumber200 {
			width: 27%;
			margin: 28px auto 0 0;
			order: 6;
		}

		.suvinilBottomText {
			width: 100%;
			max-width: 320px;
			margin: 36px 0 0 auto;
			text-align: right;
			font-size: 22px;
			order: 7;
		}

		.suvinilDentes {
			width: 290px;
			margin: 36px -32px -70px auto;
			order: 8;
		}

		.suvinilNumber strong{
			font-size: clamp(45px, 5.2vw, 82px);
		}
	}

	@media (max-width: 620px) {

		.suvinilHeader {
			display: block;
		}

		.suvinilNumber900,
		.suvinilNumber200,
		.suvinilBottomText,
		.suvinilDentes {
			position: relative;
			top: auto;
			left: auto;
			right: auto;
			bottom: auto;
		}


		.suvinilSection {
			padding: 48px 0 60px;
		}

		.suvinilContainer {
			padding: 0 24px;
		}

		.suvinilLogo {
			width: 145px;
		}

		.suvinilIntroText {
			font-size: 18px;
        	margin: 20px 0 0 0;
		}

		.suvinilPhotoCard {
			width: calc(100% + 48px);
			margin: 36px -24px 0;
		}

		.suvinilZ {
			width:125px;
			margin-top: 46px;
		}

		.suvinilPhone {
			width: 97%;
        	margin-top: -200px;
			left: 10%;

		}

		.suvinilNumber900,
		.suvinilNumber200 {
			width: 100%;
			margin-left: 0;
			margin-right: 0;
			padding: 18px 18px 16px;
			text-align: center;
		}

		.suvinilNumber900 {
			margin-top: -18px;
		}

		.suvinilNumber strong {
			font-size: 52px;
		}

		.suvinilNumber span {
			font-size: 14px;
		}

		.suvinilBottomText {
			font-size: 18px;
			text-align: center;
		}

		.suvinilDentes {
			width: 230px;
			margin-right: -24px;
		}

		&.isVisible .suvinilScroll {
			opacity: 1;
		}
	}

	@media (prefers-reduced-motion: reduce) {
		.suvinilScroll {
			animation: none !important;
			opacity: 1 !important;
			transform: none !important;
		}
	}
`;

export const SuperBonderCss = styled.div`
	width: 100%;
	background: #9beafc;
	font-family: "Barlow", sans-serif;
	overflow: hidden;

	.superBonderSection {
		width: 100%;
		min-height: 980px;
		background: #9beafc;
		position: relative;
		padding: 62px 0 0;
		overflow: hidden;
	}

	.superBonderContainer {
		width: 100%;
		max-width: 1440px;
		min-height: 905px;
		margin: 0 auto;
		position: relative;
		padding: 0 7.4%;
		box-sizing: border-box;
	}

	.superBonderHeader {
		width: 100%;
		display: flex;
		align-items: flex-start;
		position: relative;
		z-index: 10;
	}

	.superBonderLogo {
		width: 285px;
		height: auto;
		display: block;
	}

	.superBonderIntroText {
		width: 640px;
		margin: 6px 0 0 72px;
		color: #ff0b05;
		font-size: 18px;
		line-height: 1.1;
		font-weight: 500;
		letter-spacing: -0.06em;
	}

	.superBonderPhoneWrap {
		position: absolute;
		top: 120px;
		left: 48%;
		width: 430px;
		height: auto;
		display: block;
		z-index: 8;
	}

	.superBonderPhone {
		width: 100%;
		height: auto;
		display: block;
		filter: drop-shadow(0 28px 24px rgba(0, 0, 0, 0.32));
		transform: rotate(0deg) scale(1);
		transform-origin: center;
		transition:
			transform 0.75s cubic-bezier(0.22, 1, 0.36, 1),
			filter 0.75s cubic-bezier(0.22, 1, 0.36, 1);
		cursor: pointer;
		will-change: transform;
	}

	.superBonderPhoneWrap:hover .superBonderPhone {
		transform: rotate(-6deg) scale(1.035) translateY(-8px);
		filter: drop-shadow(0 38px 32px rgba(0, 0, 0, 0.40));
	}

	.superBonderNumber {
		position: absolute;
		top: 355px;
		left: 15%;
		width: 585px;
		min-height: 112px;
		background: #ff0b05;
		color: #fff7dd;
		padding: 22px 34px 16px;
		box-sizing: border-box;
		z-index: 5;
	}

	.superBonderNumber strong {
		display: block;
		font-size: clamp(58px, 5.8vw, 65px);
		line-height: 0.82;
		font-weight: 800;
		letter-spacing: -0.06em;
	}

	.superBonderNumber span {
		display: block;
		margin-top: 7px;
		font-size: clamp(14px, 1.05vw, 18px);
		line-height: 1;
		font-weight: 400;
		letter-spacing: -0.055em;
	}

	.superBonderTriangle {
		position: absolute;
		left: -22px;
		top: -23px;
		width: 82px;
		height: auto;
		display: block;
		transform: rotate(180deg);
	}

	.superBonderResultText {
		position: absolute;
		top: 178px;
		left: 16%;
		width: 430px;
		color: #ff0b05;
		z-index: 7;
	}

	.superBonderResultText h2 {
		margin: 0 0 8px;
		color: #ff0b05;
		font-size: clamp(26px, 2.1vw, 34px);
		line-height: 0.95;
		font-weight: 800;
		text-transform: uppercase;
		letter-spacing: -0.06em;
	}

	.superBonderResultText p {
		margin: 0;
		color: #ff0b05;
		font-size: clamp(16px, 1.3vw, 21px);
		line-height: 1.12;
		font-weight: 500;
		letter-spacing: -0.06em;
	}

	.superBonderArrow {
		position: absolute;
		top: 310px;
		right: 13%;
		width: 200px;
		height: auto;
		display: block;
		z-index: 3;
		transform: rotate(-45deg);
		transform-origin: center;
	}

	.superBonderPhotos {
		position: absolute;
		left: 0;
		bottom: -14px;
		width: 100%;
		height: auto;
		display: block;
		z-index: 6;
	}

	.superBonderScroll {
		opacity: 0;
		will-change: transform, opacity;
	}

	&.isVisible .superBonderLogoAnim {
		animation: superBonderFromLeft 0.85s cubic-bezier(0.22, 1, 0.36, 1) both;
	}

	&.isVisible .superBonderIntroTextAnim {
		animation: superBonderFromTop 0.85s cubic-bezier(0.22, 1, 0.36, 1) 0.25s both;
	}

	&.isVisible .superBonderPhoneAnim {
		animation: superBonderPhoneFromTop 0.95s cubic-bezier(0.22, 1, 0.36, 1) 0.62s both;
	}

	&.isVisible .superBonderNumberAnim {
		animation: superBonderFromRight 0.85s cubic-bezier(0.22, 1, 0.36, 1) 1.05s both;
	}

	&.isVisible .superBonderTextResultAnim {
		animation: superBonderFromTop 0.85s cubic-bezier(0.22, 1, 0.36, 1) 1.35s both;
	}

	&.isVisible .superBonderArrowAnim {
		animation: superBonderArrowAppear 0.85s cubic-bezier(0.22, 1, 0.36, 1) 1.7s both;
	}

	&.isVisible .superBonderPhotosAnim {
		animation: superBonderFromBottom 0.95s cubic-bezier(0.22, 1, 0.36, 1) 2.05s both;
	}

	@keyframes superBonderFromLeft {
		from {
			opacity: 0;
			transform: translateX(-120px);
		}

		to {
			opacity: 1;
			transform: translateX(0);
		}
	}

	@keyframes superBonderFromRight {
		from {
			opacity: 0;
			transform: translateX(140px);
		}

		to {
			opacity: 1;
			transform: translateX(0);
		}
	}

	@keyframes superBonderFromTop {
		from {
			opacity: 0;
			transform: translateY(-75px);
		}

		to {
			opacity: 1;
			transform: translateY(0);
		}
	}

	@keyframes superBonderFromBottom {
		from {
			opacity: 0;
			transform: translateY(90px);
		}

		to {
			opacity: 1;
			transform: translateY(0);
		}
	}

	@keyframes superBonderPhoneFromTop {
		from {
			opacity: 0;
			transform: translateY(-95px) scale(0.94);
		}

		to {
			opacity: 1;
			transform: translateY(0) scale(1);
		}
	}

	@keyframes superBonderArrowAppear {
		from {
			opacity: 0;
			transform: translateX(80px) scale(0.95) rotate(-0deg);
		}

		to {
			opacity: 1;
			transform: translateX(0) scale(1) rotate(-180deg);
		}
	}

	@media (max-width: 1366px) {
		.superBonderContainer {
			padding: 0 6%;
		}

		.superBonderIntroText {
			width: 610px;
			font-size: 20px;
			margin-left: 60px;
		}

		.superBonderPhoneWrap {
			left: 47%;
			width: 390px;
		}

		.superBonderNumber {		
			width: 540px;
		}		

		.superBonderPhotos{
			left: 0;
			bottom: -20px;
			width: 100%;
		}

	}

	@media (max-width: 1100px) {
		.superBonderSection {
			min-height: 880px;
		}

		.superBonderContainer {			
			padding: 0 32px;
		}

		.superBonderLogo {
			width: 230px;
		}

		.superBonderIntroText {
			width: 520px;
			margin-left: 48px;
			font-size: 18px;
		}

		.superBonderPhoneWrap {
			top: 145px;
			left: 39%;
			width: 399px;
		}

		.superBonderNumber {
			top: 355px;
			left: 32px;
			width: 470px;
		}

		.superBonderResultText {
			top: 255px;
			left: 32px;
			width: 390px;
		}

		.superBonderArrow {
			top: 325px;
        	right: 75px;
		}

		
	}

	@media (max-width: 900px) {
		.superBonderSection {
			min-height: auto;
			padding: 55px 0 0;
		}

		.superBonderContainer {
			min-height: auto;
			padding: 0 32px;
			display: flex;
			flex-direction: column;
			min-height: 710px;
		}

		

		.superBonderLogo {
			width: 215px;
		}

		.superBonderIntroText {
			width: 100%;
			max-width: 450px;
			margin: 0px 0 0 44px;
			font-size: 18px;
			line-height: 1.16;
		}		
		
		.superBonderPhoneWrap {
			width: 70%;
			max-width: 320px;		
			order: 2;
			top: 100px;
		}

		.superBonderResultText {
			width: 100%;
			max-width: 343px;
        	margin: -90px 0 0;
			order: 3;
		}

		.superBonderNumber {
			width: 52%;			
			order: 4;
		}

		.superBonderArrow {
			width: 163px;
			margin: -90px -10px 0 auto;
			order: 5;
		}

		.superBonderPhotos {
			width: calc(100% + 64px);
			margin: 28px -32px 0;
			order: 6;
		}
	}

	@media (max-width: 620px) {

		.superBonderPhoneWrap,
		.superBonderNumber,	
		.superBonderPhotos,
		.superBonderArrow,
		.superBonderResultText{
			position: relative;
			top: auto;
			left: auto;
			right: auto;
			bottom: auto;
		}

		.superBonderHeader {
			display: block;
		}

		.superBonderNumber{
		    width: 100%;
    		margin: 30px 0 0 0;
		}

		.superBonderSection {
			padding: 48px 0 0;
		}

		.superBonderContainer {
			padding: 0 24px;
		}

		.superBonderLogo {
			width: 190px;
		}

		.superBonderIntroText {
		    font-size: 18px;
			width: 100%;
			margin: 20px 0 0 0;
		}

		.superBonderPhoneWrap {
			width: 95%;
			margin-top: 40px;
		}

		.superBonderResultText {
			margin-top:20px;
			text-align: left;
		}

		.superBonderResultText h2 {
			font-size: 27px;
		}

		.superBonderResultText p {
			font-size: 18px;
		}

		.superBonderNumber {
			padding: 18px 18px 16px;
			text-align: center;
		}

		.superBonderNumber strong {
			font-size: 56px;
		}

		.superBonderNumber span {
			font-size: 14px;
		}

		.superBonderArrow {
			width: 150px;
			margin-top: -55px;
			display: none
		}

		.superBonderPhotos {
			width: calc(100% + 48px);
			margin: 28px -24px 0;
		}

		&.isVisible .superBonderScroll {
			opacity: 1;
		}
	}

	@media (prefers-reduced-motion: reduce) {
		.superBonderScroll {
			animation: none !important;
			opacity: 1 !important;
			transform: none !important;
		}
	}
`;

export const KevlarCss = styled.div`
	width: 100%;
	background: #f5efd9;
	font-family: "Barlow", sans-serif;
	overflow: hidden;

	.kevlarSection {
		width: 100%;
		min-height: 760px;
		background: #f5efd9;
		position: relative;
		padding: 62px 0 0;
		overflow: hidden;
	}

	.kevlarContainer {
		width: 100%;
		max-width: 1440px;
		min-height: 760px;
		margin: 0 auto;
		position: relative;
		padding: 0 7.4%;
		box-sizing: border-box;
	}

	.kevlarHeader {
		width: 100%;
		display: flex;
		align-items: flex-start;
		position: relative;
		z-index: 12;
	}

	.kevlarLogo {
		width: 240px;
		height: auto;
		display: block;
	}

	.kevlarIntroText {
		width: 550px;
		margin: 5px 0 0 68px;
		color: #ff0b05;
		font-size: 20px;
		line-height: 1.08;
		font-weight: 500;
		letter-spacing: -0.06em;
	}

	.kevlarZ {
		position: absolute;
		left: 41%;
    	top: 199px;
		width: 265px;
		height: auto;
		display: block;
		z-index: 3;
	}

	.kevlarPhoneWrap {
		position: absolute;
		left: 49%;
		top: 190px;
		width: 355px;
		z-index: 8;
		filter: drop-shadow(0 28px 24px rgba(0, 0, 0, 0.28));
		transition: transform 0.45s ease, filter 0.45s ease;
		transform-origin: center bottom;
	}

	.kevlarPhoneWrap:hover {
		transform: rotate(-2.5deg) translateY(-8px);
		filter: drop-shadow(0 34px 28px rgba(0, 0, 0, 0.34));
	}

	.kevlarPhone {
		width: 100%;
		height: auto;
		display: block;
	}

	.kevlarNumber {
		position: absolute;
		left:19%;
		top: 290px;
		width: 455px;
		min-height: 112px;
		background: #ff0b05;
		color: #fff7dd;
		padding: 18px 34px 16px;
		box-sizing: border-box;
		text-align: center;
		z-index: 6;
	}

	.kevlarNumber::before {
		content: "";
		position: absolute;
		left: -22px;
		top: -22px;
		width: 105px;
		height: 105px;
		border: 1px solid #ff0b05;
		background: transparent;
		z-index: -1;
	}

	.kevlarNumber strong {
		display: block;
		font-size: clamp(58px, 5.8vw, 88px);
		line-height: 0.82;
		font-weight: 800;
		letter-spacing: -0.06em;
	}

	.kevlarNumber span {
		display: block;
		margin-top: 7px;
		font-size: clamp(14px, 1.05vw, 18px);
		line-height: 1;
		font-weight: 400;
		letter-spacing: -0.055em;
	}

	.kevlarBottomText {
		position: absolute;
		left: 11%;
		top: 540px;
		width: 500px;
		margin: 0;
		color: #ff0b05;
		font-size:20px;
		line-height: 1.15;
		font-weight: 500;
		text-align: center;
		letter-spacing: -0.06em;
		z-index: 8;
	}

	.kevlarPhotos {
		position: absolute;
		right: -125px;
		top: 0;
		width: 40%;
		height: auto;
		display: block;
		z-index: 7;
		filter: drop-shadow(0 22px 22px rgba(0, 0, 0, 0.20));
	}

	.kevlarScroll {
		opacity: 0;
		will-change: transform, opacity;
	}

	/* 2. Logo vem da esquerda para direita */
	&.isVisible .kevlarLogoAnim {
		animation: kevlarFromLeft 0.8s cubic-bezier(0.22, 1, 0.36, 1) both;
	}

	/* 3. Texto ao lado do logo vem de cima para baixo */
	&.isVisible .kevlarIntroTextAnim {
		animation: kevlarFromTop 0.85s cubic-bezier(0.22, 1, 0.36, 1) 0.25s both;
	}

	/* Quadro de fotos aparece primeiro */
	&.isVisible .kevlarPhotosAnim {
		animation: kevlarPhotosAppear 0.95s cubic-bezier(0.22, 1, 0.36, 1) 0.68s both;
	}

	/* Depois o celular vem de cima para baixo */
	&.isVisible .kevlarPhoneAnim {
		animation: kevlarPhoneFromTop 0.95s cubic-bezier(0.22, 1, 0.36, 1) 1.12s both;
	}

	/* Z azul aparece depois do celular e fica atrás dele */
	&.isVisible .kevlarZAnim {
		animation: kevlarZAppear 0.85s cubic-bezier(0.22, 1, 0.36, 1) 1.45s both;
	}

	/* Indicador 200k vem da direita para esquerda */
	&.isVisible .kevlarNumberAnim {
		animation: kevlarFromRight 0.85s cubic-bezier(0.22, 1, 0.36, 1) 1.72s both;
	}

	&.isVisible .kevlarBottomTextAnim {
		animation: kevlarFromTop 0.85s cubic-bezier(0.22, 1, 0.36, 1) 1.98s both;
	}

	@keyframes kevlarFromLeft {
		from {
			opacity: 0;
			transform: translateX(-120px);
		}

		to {
			opacity: 1;
			transform: translateX(0);
		}
	}

	@keyframes kevlarFromRight {
		from {
			opacity: 0;
			transform: translateX(140px);
		}

		to {
			opacity: 1;
			transform: translateX(0);
		}
	}

	@keyframes kevlarFromTop {
		from {
			opacity: 0;
			transform: translateY(-75px);
		}

		to {
			opacity: 1;
			transform: translateY(0);
		}
	}

	@keyframes kevlarPhoneFromTop {
		from {
			opacity: 0;
			transform: translateY(-95px) scale(0.94);
		}

		to {
			opacity: 1;
			transform: translateY(0) scale(1);
		}
	}

	@keyframes kevlarZAppear {
		from {
			opacity: 0;
			transform: translateX(-90px) scale(0.96);
		}

		to {
			opacity: 1;
			transform: translateX(0) scale(1);
		}
	}

	@keyframes kevlarPhotosAppear {
		from {
			opacity: 0;
			transform: translateX(120px) scale(0.96) rotate(2deg);
		}

		to {
			opacity: 1;
			transform: translateX(0) scale(1) rotate(0deg);
		}
	}

	@media (max-width: 1366px) {
		.kevlarContainer {
			padding: 0 6%;
		}

		.kevlarIntroText {
			width: 600px;
			font-size: 22px;
		}

		.kevlarPhoneWrap {
			left: 46%;
			width: 330px;
		}

		.kevlarZ {
		left: 37%;
		}

		.kevlarNumber {
			left: 17%;
		}

		.kevlarPhotos {
			right: -95px;
			top: 4%;
    		width: 45%;		
		}
	}

	@media (max-width: 1100px) {
		.kevlarSection {
			min-height: 700px;
		}

		.kevlarContainer {
			min-height: 700px;
			padding: 0 32px;
		}

		.kevlarLogo {
			width: 210px;
		}

		.kevlarIntroText {
			width: 520px;
			margin-left: 48px;
			font-size: 21px;
		}

		.kevlarPhoneWrap {
			top: 210px;
			left: 43%;
			width: 285px;
		}

		.kevlarZ {
			top: 255px;
			left: 36%;
			width: 220px;
		}

		.kevlarNumber {
			top: 315px;
			left: 9%;
			width: 405px;
		}

		.kevlarBottomText {
			top: 510px;
			left: 3%;
			width: 420px;
			font-size: 20px;
		}

		.kevlarPhotos {
			top: 75px;
        	right: -80px;		
		}
	}

	@media (max-width: 900px) {
		.kevlarSection {
			min-height: auto;
			padding: 55px 0 70px;
		}

		.kevlarContainer {
			min-height: auto;
			padding: 0 32px;
			display: flex;
			flex-direction: column;
		}

		.kevlarHeader {
			display: block;
			order: 1;
		}

		.kevlarLogo {
			width: 190px;
		}

		.kevlarIntroText {
			width: 100%;
			max-width: 560px;
			margin: 28px 0 0;
			font-size: 21px;
			line-height: 1.14;
		}

		.kevlarPhoneWrap,
		.kevlarZ,
		.kevlarNumber,
		.kevlarBottomText,
		.kevlarPhotos {
			position: relative;
			top: auto;
			left: auto;
			right: auto;
			bottom: auto;
		}

		.kevlarPhoneWrap {
			width: 68%;
			max-width: 360px;
			margin: 70px auto 0;
			order: 3;
		}

		.kevlarZ {
			width: 255px;
			margin: -330px auto 0 23%;
			order: 2;
		}

		.kevlarNumber {
			width: 78%;
			margin: -20px 0 0 auto;
			order: 4;
		}

		.kevlarBottomText {
			width: 100%;
			max-width: 520px;
			margin: 36px auto 0;
			text-align: center;
			font-size: 26px;
			order: 5;
		}

		.kevlarPhotos {
			width: 78%;
			max-width: 420px;
			margin: 40px auto 0;
			order: 6;
		}
	}

	@media (max-width: 620px) {
		.kevlarSection {
			padding: 48px 0 60px;
		}

		.kevlarContainer {
			padding: 0 24px;
		}

		.kevlarLogo {
			width: 165px;
		}

		.kevlarIntroText {
			font-size: 18px;
		}

		.kevlarZ {
			width: 185px;
			margin: 35px auto 0 -1%;
		}

		.kevlarPhoneWrap {
			width: 60%;
			margin-top: -200px;
			margin-right: 35%;
		}

		.kevlarNumber {
			width: 100%;
			margin: 24px 0 0;
			padding: 18px 18px 16px;
			text-align: center;
		}

		.kevlarNumber strong {
			font-size: 56px;
		}

		.kevlarNumber span {
			font-size: 14px;
		}

		.kevlarBottomText {
			font-size: 18px;
			text-align: center;
		}

		.kevlarPhotos {
			width: 80%;
			top:15%;
			right: -28%;
			position: absolute;
		}

		&.isVisible .kevlarScroll {
			opacity: 1;
		}
	}

	@media (prefers-reduced-motion: reduce) {
		.kevlarScroll {
			animation: none !important;
			opacity: 1 !important;
			transform: none !important;
		}
	}
`;

